import {FieldConfig} from './descriptor-types';
import {ERROR_MESSAGES, MAX_TEXT_LENGTH, URI_REGEX} from './descriptor-constants';

/**
 * Configuration for all form fields in the descriptor editor
 */
export const DESCRIPTOR_FIELD_CONFIG: FieldConfig[] = [
    {
        name: 'name',
        label: 'Name',
        type: 'text',
        required: true,
        maxLength: MAX_TEXT_LENGTH,
        validation: {
            message: ERROR_MESSAGES.NAME_REQUIRED
        }
    },
    {
        name: 'status',
        label: 'State',
        type: 'readonly'
    },
    {
        name: 'uri',
        label: 'URI',
        type: 'text',
        required: false,
        validation: {
            pattern: URI_REGEX,
            message: ERROR_MESSAGES.URI_INVALID
        }
    },
    {
        name: 'groupId',
        label: 'Working Area',
        type: 'select',
        required: true
    },
    {
        name: 'description',
        label: 'Description',
        type: 'text',
        required: true,
        multiline: true,
        rows: 4,
        maxLength: MAX_TEXT_LENGTH,
        validation: {
            message: ERROR_MESSAGES.DESCRIPTION_REQUIRED
        }
    }
];

/**
 * Layout configuration for form fields
 */
export const FIELD_LAYOUT = {
    nameAndState: ['name', 'status'],
    uriAndGroup: ['uri', 'groupId'],
    description: ['description']
};

/**
 * Get field configuration by name
 */
export function getFieldConfig(fieldName: string): FieldConfig | undefined {
    return DESCRIPTOR_FIELD_CONFIG.find(field => field.name === fieldName);
}

/**
 * Get fields for a specific layout row
 */
export function getLayoutFields(layoutKey: keyof typeof FIELD_LAYOUT): FieldConfig[] {
    const fieldNames = FIELD_LAYOUT[layoutKey];
    return fieldNames
        .map(name => getFieldConfig(name))
        .filter((config): config is FieldConfig => config !== undefined);
}

/**
 * Terms table configuration
 */
export const TERMS_TABLE_CONFIG = {
    columns: [
        { id: 'term', label: 'Term', width: '30%' },
        { id: 'definition', label: 'Definition', width: '60%' },
        { id: 'actions', label: '', width: '10%' }
    ],
    instructions: 'The descriptor terms are defined as a list of key-value pairs. To add new terms, click the add button below the table. Add as many terms as necessary to capture the scope of the event.'
};

/**
 * Button configurations
 */
export const BUTTON_CONFIG = {
    addTerm: {
        label: 'Add New Term',
        variant: 'contained' as const,
        icon: 'AddIcon'
    },
    publish: {
        label: 'Publish',
        variant: 'contained' as const,
        icon: 'PublicIcon'
    },
    save: {
        label: 'Save',
        variant: 'contained' as const,
        icon: 'SaveAltIcon'
    },
    removeTerm: {
        label: 'Remove Term',
        variant: 'contained' as const,
        color: 'error' as const,
        icon: 'DeleteIcon'
    }
};